<p class="dialog">Выберите, кому хотели бы написать</p>
